import type { VoidFunctionComponent } from 'react';
import Section from '../../../shared/settings/SettingsPageSection';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import type { GenericIssueSettingsProps } from './types';

/**
 * ProjectSecurityIssuesSettings
 */
const ProjectSecurityIssuesSettings: VoidFunctionComponent<GenericIssueSettingsProps> = (props) => {
  return (
    <Section>
      <Section.Left heading="Security">
        <Section.Paragraph>Configuration for security issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Vulnerability}
          scopeType={IssueScopeKind.Project}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectSecurityIssuesSettings;
